class PowerfulHeader extends HTMLElement {
    constructor() {
      super();

      this.dropdowns = this.querySelectorAll('header-dropdown, details-modal');
      this.header = this.querySelector('.header');
      this.mobileMenuDrawer = this.querySelector('mobile-menu-drawer');

      this.topLevelLinks = this.querySelectorAll('a.header__menu-item');
      this.topLevelLinks.forEach(link => link.addEventListener('mouseenter', this.closeModals.bind(this)));

      this.addEventListener('mouseenter', this.onEnter);
      this.addEventListener('mouseleave', this.onLeave);
      this.handleHeaderVisibility();
    }

    handleHeaderVisibility() {
      let trackerId = "PowerfulHeader-VisibilityTracker";
      this.visibilityTracker ||= document.getElementById(trackerId) || document.createElement('div');
      if (!this.visibilityTracker.id) {
        this.visibilityTracker.id = trackerId;
      }

      this.main = document.getElementById('main');
      document.body.prepend(this.visibilityTracker);

      let rootMargin = "0px 0px 0px 0px";

      this.scrollObserver = new IntersectionObserver(
        entries => {
          let entry = entries[0];

          if (entry.isIntersecting) {
            this.onReachingTop();
          } else {
            this.onScrollingPast();
          }
        },
        {
          rootMargin: rootMargin
        }
      )
        .observe(this.visibilityTracker);
    }

    onEnter() {
      this.activate();
    }

    onLeave(ev) {
      this.deactivate();
    }

    onReachingTop() {
      this.header.classList.remove('stuck');
    }

    onScrollingPast() {
      this.header.classList.add('stuck');
    }

    activate() {
      this.header.classList.add('active');
      this.closeModals();
    }

    deactivate() {
      if (this.mobileMenuDrawer.isOpen()) return;

      this.header.classList.remove('active');
      this.closeModals();
    }

    closeModals() {
      this.dropdowns.forEach((dropdown) => dropdown.closeModal());
    }
  }

  customElements.define('powerful-header', PowerfulHeader);

  class HeaderDropdown extends DetailsModal {
    constructor() {
      super();

      this.content = this.details.querySelector('.modal__content');
      this.images = this.content.querySelectorAll('.header-dropdown__images .media');

      this.summary.addEventListener('mouseenter', this.onEnter.bind(this));
      this.addEventListener('mouseover', this.onMouseOverLink.bind(this));
    }

    connectedCallback() {
    }

    onMouseOverLink(ev) {
      [...this.images].forEach(media => media.classList.remove('active'));

      if (!ev.target.dataset.mediaId) return

      document.getElementById(ev.target.dataset.mediaId)?.classList?.add('active');
    }

    onEnter(ev) {
      this.open(ev);
    }
  }

  customElements.define('header-dropdown', HeaderDropdown);
